import React from 'react'
import { useDatabase } from '../DatabaseContext'
import { useAdDatabase } from '../AdDatabaseContext'
import FillDetailsForm from './FillDetailsForm'
import PostCard from './PostCard'
import PostQuestionsCard from './PostQuestionsCard'
import QuestionCard from './QuestionCard'
import AdQuestionCard from './AdQuestionCard'



import AdPostCard from './AdPostCard'
import AdPostQuestionsCard from './AdPostQuestionsCard'

import EndMessageCard from './EndMessageCard'

function AdHomePage() {

  const { appState, curUser, totalStates } = useAdDatabase()

  return (
    <div className='HomePage'>
      {appState === 0 ?
        <FillDetailsForm /> :
        appState <= curUser.postsOrder.length ?
          <AdPostCard id={curUser.postsOrder[(appState - 1) % curUser.postsOrder.length]} /> :
          appState <= 2 * curUser.postsOrder.length ?
            <AdPostQuestionsCard id={curUser.postsOrder[(appState - 1) % curUser.postsOrder.length]} /> :
            appState < totalStates ?
              <AdQuestionCard id={appState - 2 * curUser.postsOrder.length} /> :
              <EndMessageCard />
      }
    </div>
  )
}

export default AdHomePage
